export const NumberFormatter = (x) => {
  const value = Number(x || 0);
  const formattedWithOptions = value.toLocaleString('en-NG', {
   minimumFractionDigits: 0,
   maximumFractionDigits: 0,
 });
  return formattedWithOptions
  }

  export const NumberQuote =(number)=>{
    let value = Number(number)
    if(value>999999999){
            return ((value/1000000000).toFixed(2)).toString()+"B";
       }else if((value>999999)&&(value<999999999)){
         return ((value/1000000).toFixed(2)).toString()+"M";
    }else if((value>999)&&(value<999999)){
            return ((value/1000).toFixed(2)).toString()+"K";
     }else{
            return value.toLocaleString('en-NG')
     }
}
